import type { ModelProps, ModelRegistry } from '../types';

function AlpineFlower({ world }: ModelProps) {
  return (
    <group>
      {/* Small stem */}
      <mesh position={[0, 0.08, 0]}>
        <cylinderGeometry args={[0.01, 0.015, 0.15, 4]} />
        <meshStandardMaterial color="#4CAF50" roughness={0.7} />
      </mesh>
      {/* Fuzzy leaves at base */}
      {[0, 1, 2].map((i) => (
        <mesh key={i} position={[Math.cos(i * 2.1) * 0.04, 0.02, Math.sin(i * 2.1) * 0.04]} rotation={[0.4, i * 2.1, 0]}>
          <planeGeometry args={[0.05, 0.03]} />
          <meshStandardMaterial color="#7CB342" side={2} roughness={0.8} />
        </mesh>
      ))}
      {/* Star-shaped white petals */}
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <mesh key={i} position={[Math.cos(i * Math.PI / 3) * 0.04, 0.16, Math.sin(i * Math.PI / 3) * 0.04]} rotation={[0.3, i * Math.PI / 3, 0]}>
          <planeGeometry args={[0.04, 0.06]} />
          <meshStandardMaterial
            color={world === 'real' ? '#FFFAF0' : '#E6E6FA'}
            side={2}
            roughness={0.4}
          />
        </mesh>
      ))}
      {/* Yellow center */}
      <mesh position={[0, 0.16, 0]}>
        <sphereGeometry args={[0.02, 6, 6]} />
        <meshStandardMaterial color={world === 'real' ? '#FFD700' : '#DDA0DD'} />
      </mesh>
    </group>
  );
}

function MountainGrass({ world }: ModelProps) {
  return (
    <group>
      {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((i) => {
        const angle = (i * Math.PI * 2) / 9;
        const dist = 0.05 + (i % 3) * 0.03;
        return (
          <mesh key={i} position={[Math.cos(angle) * dist, 0.1, Math.sin(angle) * dist]} rotation={[0.15 * Math.sin(i), 0, 0.1 * Math.cos(i)]}>
            <coneGeometry args={[0.012, 0.2 + (i % 3) * 0.05, 4]} />
            <meshStandardMaterial
              color={world === 'real' ? '#8FBC8F' : '#5a7a5a'}
              roughness={0.8}
            />
          </mesh>
        );
      })}
    </group>
  );
}

export const mountainModels: ModelRegistry = {
  alpine_flower: AlpineFlower,
  mountain_grass: MountainGrass,
};
